const EmptyWatchlist = () => {
    return (<svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M40 35H88V39H40V35ZM32 35H36V39H32V35ZM101 15H19C16.5 15 15 16.5 15 19V101C15 103 16.5 105 19 105H101C103 105 105 103 105 101V19C105 16.5 103 15 101 15ZM101 101H19L19 19H101V101Z"
                fill="currentColor"/>
            <path d="M88 50H40V54H88V50Z" fill="currentColor"/>
            <path d="M36 50H32V54H36V50Z" fill="currentColor"/>
            <path d="M88 65H40V69H88V65Z" fill="currentColor"/>
            <path d="M36 65H32V69H36V65Z" fill="currentColor"/>
            <path d="M88 80H40V84H88V80Z" fill="currentColor"/>
            <path d="M36 80H32V84H36V80Z" fill="currentColor"/>
        </svg>

    )
}
export default EmptyWatchlist
